import {type CardEnum, type MechanicDevelopmentCardsPlayerState} from '@colonist/game-states'
import {CardValidatorOrdered} from '../core/card/CardValidatorOrdered.ts'

export class MechanicValidatorDevelopmentCardPlayer {
    private readonly developmentCardPlayerState: MechanicDevelopmentCardsPlayerState
    developmentCards: CardValidatorOrdered

    constructor(developmentCardPlayerState: MechanicDevelopmentCardsPlayerState) {
        this.developmentCardPlayerState = developmentCardPlayerState
        this.developmentCards = new CardValidatorOrdered(this.developmentCardPlayerState.developmentCards)
    }

    get developmentCardsBoughtThisTurn(): CardEnum[] {
        return this.developmentCardPlayerState.developmentCardsBoughtThisTurn ?? []
    }

    get developmentCardsUsed(): CardEnum[] {
        return this.developmentCardPlayerState.developmentCardsUsed
    }

    get hasUsedDevelopmentCardThisTurn(): true | undefined {
        return this.developmentCardPlayerState.hasUsedDevelopmentCardThisTurn
    }
}
